import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { ApiService, HttpParamsOptions } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { datePickerMinDate } from '../../shared/constants';
import { catchError, tap } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { slideInAnimation } from '../../animations/route-animation';
import { ChartConfiguration } from 'chart.js';
import { addDays, addMonths } from 'date-fns';
import { LegendPosition } from '@swimlane/ngx-charts';
import moment from 'moment';
import { DataTableDirective } from 'angular-datatables';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Config } from 'datatables.net';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-company-dashboard',
	templateUrl: './company-dashboard.component.html',
	styleUrl: './company-dashboard.component.scss',
	animations: [
		trigger('fadeInOut', [
			state('void', style({
				opacity: 0
			})),
			transition(':enter, :leave', [
				animate(500)
			])
		]),
		slideInAnimation
	]
})
export class CompanyDashboardComponent implements OnInit {
	loader1 = false;
	loader2 = false;
	loader3 = false;
	loader4 = false;
	loader5 = false;
	loader10 = false;
	loader12 = false;
	loader13 = false;
	loader14 = false;
	loader15 = false;
	loader16 = false;
	loader17 = false;
	loader18 = false;
	loader19 = false;
	loader20 = false;
	loader21 = false;
	filterToday: any = {
		date: new Date()
	};
	filterTeleCon: any = {
		date: new Date()
	};
	snapshotData1: any = null;
	snapshotData2: any = null;
	illnessAppts: any[] = [];
	hospSurgAppts: any[] = [];
	disabilityAppts: any[] = [];
	injuryAppts: any[] = [];
	getYearList() {
		let yyyy = new Date().getFullYear();
		let yearList: any[] = [];
		for (let i = 0; i < 10; i++) {
			yearList.push({ value: yyyy, name: yyyy });
			yyyy -= 1;
		}
		return yearList;
	}
	yearList: any[] = this.getYearList();
	monthList = [
		{ value: 1, name: "Janurary" },
		{ value: 2, name: "February" },
		{ value: 3, name: "March" },
		{ value: 4, name: "April" },
		{ value: 5, name: "May" },
		{ value: 6, name: "June" },
		{ value: 7, name: "July" },
		{ value: 8, name: "August" },
		{ value: 9, name: "September" },
		{ value: 10, name: "October" },
		{ value: 11, name: "November" },
		{ value: 12, name: "December" },
	]
	getFirstDayOfCurrentMonth() {
		const now = new Date();
		const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
		return firstDay;
	}
	getCurrentMonth() {
		let month = new Date().getMonth() + 1;
		return month;
	}
	filters1: any = {
		year: new Date().getFullYear(),
		start_date: addMonths(new Date(), -1),
		end_date: new Date()
	};
	filters2: any = {
		start_date: this.getFirstDayOfCurrentMonth(),
		end_date: new Date()
	};
	filters3: any = {
		start_year: new Date().getFullYear(),
		start_month: this.getCurrentMonth(),
		end_year: new Date().getFullYear(),
		end_month: this.getCurrentMonth(),
	};
	/* filters4: any = {
		start_month: this.getCurrentMonth(),
		start_year: "2025"
	}; */
	filters5: any = {
		flag: "illness_total_cases"
	};
	barChartOptions: ChartConfiguration['options'] = {
		responsive: true,
		scales: {
			x: {
				stacked: true
			},
			y: {
				stacked: true,
				ticks: {
					precision: 0
				}
			}
		},
		aspectRatio: 4
	};

	catChartData: ChartConfiguration<'bar'>['data'] = {
		labels: [],
		datasets: []
	};
	icd_code_data_illness: any = [];
	icd_code_data_injury: any = [];
	hospitalized_data: any = [];
	minDate = datePickerMinDate;
	legendPosition: LegendPosition = LegendPosition.Right;
	arcWidth = 0.50;
	showPieChartLabels = true;
	showPieChartLegend = true;
	isDoughnut = true;
	gradient = true;
	billed_unbilled_count: any = {};
	colorArr1 = ['#ffa01b', '#0D6EFD', '#DC3545', '#177B4C', '#f72119', '#ffa01b', '#690000', '#ff355e', '#ff9933', '#ffcc33', '#006b3c', '#ccff00', '#16d0cb'];
	colorArr2 = ['#5AA454', '#ffe417', '#f72119', '#ffa01b', '#5AA454', '#ffe417', '#f72119', '#ffa01b', '#690000', '#66ff66', '#aaf0d1', '#fd5b78', '#50bfe6'];
	colorArr3 = ['#211bd1', '#ffe417', '#f72119', '#ffa01b', '#690000', '#5AA454', '#C7B42C', '#AAAAAA', '#021B4D', '#C00000', '#ff6037', '#ff9966', '#9c27b0'];
	colorScheme1: any = {
		domain: this.colorArr1
	};
	colorScheme2: any = {
		domain: this.colorArr2
	};
	colorScheme3: any = {
		domain: this.colorArr3
	};
	case_list_by_flag_new: any[] = [];
	case_list_by_flag_closed: any[] = [];
	case_list_by_flag_ill_lt_31: any[] = [];
	case_list_by_flag_inj_lt_31: any[] = [];
	case_list_by_flag_ill_gt_31: any[] = [];
	case_list_by_flag_inj_gt_31: any[] = [];
	user: any = null;

	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	dtOptions: Config = {};
	dataList: any = [];
	fieldset = [
		{
			category: "Illness",
			bg: "bg-illness",
			snapshot_fields: [
				{ label: "Total Cases", key: "illness_total_cases" },
				{ label: "Open Cases", key: "illness_open_cases" },
				{ label: "Closed Cases", key: "illness_closed_cases" },
				{ label: "Billed", key: "illness_billed_cases" },
				{ label: "Unbilled (Beyond 1 month)", key: "illness_unbilled_cases" },
				{ label: "Closed within 1 month", key: "illness_cases_in_45_days" },
				{ label: "Closed within 2 months", key: "illness_cases_in_75_days" },
				{ label: "Closed after 2 months", key: "illness_cases_more_75_days" },
				{ label: "Open for 1 month", key: "illness_open_for_45_days" },
				{ label: "Open for 2 months", key: "illness_open_for_75_days" },
				{ label: "Open for more than 2 months", key: "illness_open_for_more_75_days" }
			],
			/* monthly_fields: [
				{ label: "New Cases", key: "new_illness_cases" },
				{ label: "Closed Cases", key: "closed_illness_cases" },
			] */
		},
		{
			category: "Injury",
			bg: "bg-injury",
			snapshot_fields: [
				{ label: "Total Cases", key: "injury_total_cases" },
				{ label: "Open Cases", key: "injury_open_cases" },
				{ label: "Closed Cases", key: "injury_closed_cases" },
				{ label: "Billed", key: "injury_billed_cases" },
				{ label: "Unbilled (Beyond 1 month)", key: "injury_unbilled_cases" },
				{ label: "Closed within 1 month", key: "injury_cases_in_45_days" },
				{ label: "Closed within 2 months", key: "injury_cases_in_75_days" },
				{ label: "Closed after 2 months", key: "injury_cases_more_75_days" },
				{ label: "Open for 1 month", key: "injury_open_for_45_days" },
				{ label: "Open for 2 months", key: "injury_open_for_75_days" },
				{ label: "Open for more than 2 months", key: "injury_open_for_more_75_days" }
			],
			/* monthly_fields: [
				{ label: "New Cases", key: "new_injury_cases" },
				{ label: "Closed Cases", key: "closed_injury_cases" },
			] */
		},
		{
			category: "Total",
			bg: "bg-theme",
			snapshot_fields: [
				{ label: "Total Cases", key: "total_cases" },
				{ label: "Open Cases", key: "total_open_cases" },
				{ label: "Closed Cases", key: "total_closed_cases" },
				{ label: "Billed", key: "total_billed_cases" },
				{ label: "Unbilled (Beyond 1 month)", key: "total_unbilled_cases" },
				{ label: "Closed within 1 month", key: "total_closed_in_45_days" },
				{ label: "Closed within 2 months", key: "total_closed_in_75_days" },
				{ label: "Closed after 2 months", key: "total_closed_more_75_days" },
				{ label: "Open for 1 month", key: "total_open_for_45_days" },
				{ label: "Open for 2 months", key: "total_open_for_75_days" },
				{ label: "Open for more than 2 months", key: "total_open_for_more_75_days" }
			],
			/* monthly_fields: [
				{ label: "New Cases", key: "new_cases" },
				{ label: "Closed Cases", key: "closed_cases" },
			] */
		}
	];

	constructor(private http: HttpClient, private router: Router, private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService) { }
	ngOnInit(): void {
		this.apiService.userData$.subscribe((user) => {
			if (user) {
				this.user = user;
				if (this.user.usertype == "Company") {
					this.initDatatable();
					this.getAllData();
				}
			}
		})
	}

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			searching: false,
			layout: {
				top: [],
				topStart: [],
				topEnd: [],
				bottomStart: [],
				bottomEnd: [],
				bottom: ['pageLength', 'info', 'paging']
			},
			ajax: (dataTablesParameters: any, callback) => {
				let data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length,
					...this.getFilterForTable()
				}
				this.apiService.caseListFromSnapshot(data).subscribe({
					next: (response: any) => {
						this.dataList = response.res;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						if (error.status == 404) { return }
						this.toastr.error("Something went wrong.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	findFieldType() {
		for (const fieldsetItem of this.fieldset) {
			if (fieldsetItem.snapshot_fields.some(f => f.key === this.filters5.flag)) {
				return 'snapshot';
			}
			/* if (fieldsetItem.monthly_fields.some(f => f.key === this.filters5.flag)) {
				return 'month';
			} */
		}
		return null;
	}

	getHeading() {
		for (const fieldsetItem of this.fieldset) {
			for (const catItem of [...fieldsetItem.snapshot_fields/* , ...fieldsetItem.monthly_fields */]) {
				if (catItem.key === this.filters5.flag) {
					return fieldsetItem.category + " - " + catItem.label;
				}
			}
		}
		return null;
	}

	getFilterForTable() {
		const main = this.findFieldType();
		if (!main) {
			this.toastr.error("Something went wrong.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}
		/* const snapshotfilter = main == "snapshot" ? this.getSnapshot1Filter() : this.getSnapshot2Filter(); */
		const snapshotfilter = this.getSnapshot1Filter();
		let data: any = {
			flag: this.filters5.flag,
			main: main,
			...snapshotfilter
		};
		return data;
	}

	refreshTable() {
		if (this.datatableElement) {
			this.datatableElement.dtInstance.then((dtInstance) => {
				dtInstance.draw();
			});
		}
	}

	getAllData() {
		this.getSnapshotData1();
		/* this.getSnapshotData2(); */
		this.getIllnessAppointments();
		this.getHospSurgeryAppointments();
		this.getDisabilityAppointments();
		this.getInjuryAppointments();
		this.getCategoryChart();
		this.getDateWiseData();
		this.getNewClosedData();
	}

	getSnapshot1Filter() {
		let data = {
			start_year: this.filters3.start_year,
			start_month: this.filters3.start_month,
			end_year: this.filters3.end_year,
			end_month: this.filters3.end_month,
			company: this.user.company
		}
		return data;
	}

	getSnapshotData1() {
		const from = moment({ year: this.filters3.start_year, month: this.filters3.start_month - 1 });
		const to = moment({ year: this.filters3.end_year, month: this.filters3.end_month - 1 });
		if (from.isAfter(to, 'month')) {
			this.toastr.error('Invalid input', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.loader1 = true;
		this.apiService.getSnapshotCompanyData1(this.getSnapshot1Filter()).subscribe({
			next: (data: any) => {
				this.loader1 = false;
				this.snapshotData1 = data.res;
			}, error: (error) => {
				this.loader1 = false;
				this.snapshotData1 = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
		this.refreshTable();
	}

	/* getSnapshot2Filter() {
		let data = {
			start_year: this.filters4.start_year,
			start_month: this.filters4.start_month,
			company: this.user.company
		}
		return data;
	}

	getSnapshotData2() {
		this.loader2 = true;
		this.apiService.getSnapshotCompanyData2(this.getSnapshot2Filter()).subscribe({
			next: (data: any) => {
				this.loader2 = false;
				this.snapshotData2 = data.res;
			}, error: (error) => {
				this.loader2 = false;
				this.snapshotData2 = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
		this.refreshTable();
	} */

	getDateWiseData() {
		if (!this.filters1.start_date || !this.filters1.end_date) {
			this.toastr.error('Please select dates', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		const from = moment(this.filters1.start_date);
		const to = moment(this.filters1.end_date);
		if (from.isAfter(to, 'date')) {
			this.toastr.error('Invalid input', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.getIcdCodeWiseCount();
		this.getHospitalizedOtherCounts();
		this.getBilledUnbilledCounts();
	}

	getNewClosedData() {
		const from = moment(this.filters2.start_date);
		const to = moment(this.filters2.end_date);
		if (from.isAfter(to, 'date')) {
			this.toastr.error('Invalid input', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.getCaseListByFlagNew();
		this.getCaseListByFlag_Closed();
		this.getCaseListByFlag_Ill_LT_31();
		this.getCaseListByFlag_Inj_LT_31();
		this.getCaseListByFlag_Ill_GT_31();
		this.getCaseListByFlag_Inj_GT_31();
	}

	getIllnessAppointments() {
		let data = {
			flag: "illness_more_than_90",
			company: this.user.company
		}
		this.loader3 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader3 = false;
				this.illnessAppts = data;
			}, error: (error) => {
				this.loader3 = false;
				this.illnessAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getHospSurgeryAppointments() {
		let data = {
			flag: "hospital-surgery",
			company: this.user.company
		}
		this.loader4 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader4 = false;
				this.hospSurgAppts = data;
			}, error: (error) => {
				this.loader4 = false;
				this.hospSurgAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getDisabilityAppointments() {
		let data = {
			flag: "disability",
			company: this.user.company
		}
		this.loader5 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader5 = false;
				this.disabilityAppts = data;
			}, error: (error) => {
				this.loader5 = false;
				this.disabilityAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getInjuryAppointments() {
		let data = {
			flag: "injury_more_than_180",
			company: this.user.company
		}
		this.loader10 = true;
		this.apiService.followupListDashboard(data).subscribe({
			next: (data: any) => {
				this.loader10 = false;
				this.injuryAppts = data;
			}, error: (error) => {
				this.loader10 = false;
				this.injuryAppts = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getYearFilter() {
		let payload = {
			company: this.user.company,
			year: this.filters1.year
		}
		return payload;
	}

	createDiagonalPattern(color = 'black'): CanvasPattern {
		const size = 10;
		const stroke = 2;
		const shape = document.createElement('canvas');
		shape.width = shape.height = size;
		const ctx = shape.getContext('2d')!;
		ctx.strokeStyle = color;
		ctx.lineWidth = stroke;
		ctx.beginPath();
		ctx.moveTo(0, size);
		ctx.lineTo(size, 0);
		ctx.stroke();
		return ctx.createPattern(shape, 'repeat')!;
	}

	getCategoryChart() {
		this.loader12 = true;
		this.apiService.monthWiseCountChart(this.getYearFilter()).subscribe({
			next: (data: any) => {
				this.catChartData = {
					labels: data.map((d) => d.month),
					datasets: [
						{
							label: 'Illness Open',
							data: data.map((d) => d["illness"]["open"]),
							stack: 'Illness',
							backgroundColor: '#1f77b4',
							borderColor: '1f77b4',
							borderWidth: 1
						},
						{
							label: 'Illness Closed',
							data: data.map((d) => d["illness"]["closed"]),
							stack: 'Illness',
							backgroundColor: this.createDiagonalPattern('#1f77b4'),
							borderColor: '1f77b4',
							/* borderColor: 'aec7e8', */
							borderWidth: 1
						},
						{
							label: 'Injury Open',
							data: data.map((d) => d["injury"]["open"]),
							stack: 'Injury',
							backgroundColor: '#d62728',
							borderColor: 'd62728',
							borderWidth: 1
						},
						{
							label: 'Injury Closed',
							data: data.map((d) => d["injury"]["closed"]),
							stack: 'Injury',
							backgroundColor: this.createDiagonalPattern('#d62728'),
							borderColor: 'd62728',
							/* borderColor: 'ff9896', */
							borderWidth: 1
						}
					]
				};
				this.loader12 = false;
			}, error: (error) => {
				this.catChartData = {
					labels: [],
					datasets: []
				};
				this.loader12 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getDateFilter() {
		let payload = {
			company: this.user.company,
			start_date: this.apiService.getDateStringFromDate(this.filters1.start_date),
			end_date: this.apiService.getDateStringFromDate(this.filters1.end_date)
		}
		return payload;
	}

	getIcdCodeWiseCount() {
		this.icd_code_data_illness = [];
		this.icd_code_data_injury = [];
		this.loader13 = true;
		this.apiService.icdCodeWiseCount(this.getDateFilter()).subscribe({
			next: (data: any) => {
				let icd_code_data_illness: any[] = [];
				let len1 = data.data_illness.labels.length;
				for (let i = 0; i < len1; i++) {
					icd_code_data_illness.push({
						name: data.data_illness.labels[i],
						value: data.data_illness.data[i]
					})
				}
				this.icd_code_data_illness = [...icd_code_data_illness];
				let icd_code_data_injury: any[] = [];
				let len2 = data.data_injury.labels.length;
				for (let i = 0; i < len2; i++) {
					icd_code_data_injury.push({
						name: data.data_injury.labels[i],
						value: data.data_injury.data[i]
					})
				}
				this.icd_code_data_injury = [...icd_code_data_injury];
				this.loader13 = false;
			}, error: (error) => {
				this.icd_code_data_illness = [];
				this.icd_code_data_injury = [];
				this.loader13 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getHospitalizedOtherCounts() {
		this.hospitalized_data = [];
		this.loader15 = true;
		this.apiService.hospitalizedOtherCounts(this.getDateFilter()).subscribe({
			next: (data: any) => {
				let hospitalized_data: any[] = [];
				let len1 = data.labels.length;
				for (let i = 0; i < len1; i++) {
					hospitalized_data.push({
						name: data.labels[i],
						value: data.data[i]
					})
				}
				this.hospitalized_data = [...hospitalized_data];
				this.loader15 = false;
			}, error: (error) => {
				this.hospitalized_data = [];
				this.loader15 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getBilledUnbilledCounts() {
		this.billed_unbilled_count = {};
		this.loader14 = true;
		this.apiService.billedUnbilledCounts(this.getDateFilter()).subscribe({
			next: (data: any) => {
				this.billed_unbilled_count = data;
				this.loader14 = false;
			}, error: (error) => {
				this.billed_unbilled_count = {};
				this.loader14 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getDateFilter1() {
		let payload = {
			company: this.user.company,
			start_date: this.apiService.getDateStringFromDate(this.filters2.start_date),
			end_date: this.apiService.getDateStringFromDate(this.filters2.end_date)
		}
		return payload;
	}

	getCaseListByFlagNew() {
		this.loader16 = true;
		this.apiService.caseListByFlag({ ...this.getDateFilter1(), flag: "new" }).subscribe({
			next: (data: any) => {
				this.case_list_by_flag_new = data.res;
				this.loader16 = false;
			}, error: (error) => {
				this.case_list_by_flag_new = [];
				this.loader16 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getCaseListByFlag_Closed() {
		this.loader17 = true;
		this.apiService.caseListByFlag({ ...this.getDateFilter1(), flag: "closed" }).subscribe({
			next: (data: any) => {
				this.case_list_by_flag_closed = data.res;
				this.loader17 = false;
			}, error: (error) => {
				this.case_list_by_flag_closed = [];
				this.loader17 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getCaseListByFlag_Ill_LT_31() {
		this.loader18 = true;
		this.apiService.caseListByFlag({ ...this.getDateFilter1(), flag: "illness_less_31" }).subscribe({
			next: (data: any) => {
				this.case_list_by_flag_ill_lt_31 = data.res;
				this.loader18 = false;
			}, error: (error) => {
				this.case_list_by_flag_ill_lt_31 = [];
				this.loader18 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getCaseListByFlag_Inj_LT_31() {
		this.loader19 = true;
		this.apiService.caseListByFlag({ ...this.getDateFilter1(), flag: "injury_less_31" }).subscribe({
			next: (data: any) => {
				this.case_list_by_flag_inj_lt_31 = data.res;
				this.loader19 = false;
			}, error: (error) => {
				this.case_list_by_flag_inj_lt_31 = [];
				this.loader19 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getCaseListByFlag_Ill_GT_31() {
		this.loader20 = true;
		this.apiService.caseListByFlag({ ...this.getDateFilter1(), flag: "illness_more_31" }).subscribe({
			next: (data: any) => {
				this.case_list_by_flag_ill_gt_31 = data.res;
				this.loader20 = false;
			}, error: (error) => {
				this.case_list_by_flag_ill_gt_31 = [];
				this.loader20 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	getCaseListByFlag_Inj_GT_31() {
		this.loader21 = true;
		this.apiService.caseListByFlag({ ...this.getDateFilter1(), flag: "injury_more_31" }).subscribe({
			next: (data: any) => {
				this.case_list_by_flag_inj_gt_31 = data.res;
				this.loader21 = false;
			}, error: (error) => {
				this.case_list_by_flag_inj_gt_31 = [];
				this.loader21 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}
}
